export default __webpack_public_path__ + "static/Charcoal-1ef3f77dc3c0fcc3ec69a1a024699b86.png";